import React from "react";
import { AiOutlineBulb, AiOutlineDatabase, AiOutlineMail } from "react-icons/ai";
import { BiAddToQueue, BiCollection, BiFolderPlus, BiHomeAlt, BiSearchAlt } from "react-icons/bi";
import { BsBriefcase, BsCardChecklist, BsListUl } from "react-icons/bs";
import { FaClipboardList, FaSearchengin } from "react-icons/fa";
import { FiGrid, FiServer, FiUser, FiUsers } from "react-icons/fi";
import { GrDocumentConfig } from "react-icons/gr";
import { ImFileText2, ImStack } from "react-icons/im";
import { MdAssignmentTurnedIn, MdSecurity, MdViewModule } from "react-icons/md";
import { RiLogoutBoxRLine, RiRemoteControl2Line } from "react-icons/ri";
import { SiMinutemailer } from "react-icons/si";

const iconComponent = {
  FiUser: FiUser,
  RiLogoutBoxRLine: RiLogoutBoxRLine,
  BiHomeAlt: BiHomeAlt,
  BiFolderPlus: BiFolderPlus,
  ImStack: ImStack,
  FiUsers: FiUsers,
  BsListUl: BsListUl,
  FiServer: FiServer,
  FiGrid: FiGrid,
  BsCardChecklist: BsCardChecklist,
  AiOutlineBulb: AiOutlineBulb,
  MdViewModule: MdViewModule,
  ImFileText2: ImFileText2,
  SiMinutemailer: SiMinutemailer,
  BiCollection: BiCollection,
  GrDocumentConfig: GrDocumentConfig,
  BiAddToQueue: BiAddToQueue,
  BiSearchAlt: BiSearchAlt,
  RiRemoteControl2Line: RiRemoteControl2Line,
  FaSearchengin: FaSearchengin,
  BsBriefcase: BsBriefcase,
  AiOutlineMail: AiOutlineMail,
  AiOutlineDatabase: AiOutlineDatabase,
  MdAssignmentTurnedIn: MdAssignmentTurnedIn,
  MdSecurity: MdSecurity,
  FaClipboardList: FaClipboardList,
};

export default iconComponent;
